<template>
  <div :class="isPC ? 'invite-success' :'invite-success-mobile'" id="invite-success">
    <Icon v-if="isPC"></Icon>
    <Top v-if="!isPC"></Top>
    <Iconsuccess :style="{ marginTop: (isPC ? '30px' : '80px') }"></Iconsuccess>
    <p v-if="!$route.query.invitename && !$route.query.invitegroup">{{ title3 }}</p>
    <p v-else-if="+$route.query.invitetype === 1">{{ title1 }}</p>
    <p v-else-if="+$route.query.invitetype === 3">{{ title4 }}</p>
    <p v-else>{{ title2 }}</p>
    <Buttons :type="'open'"></Buttons>
    <div class="title" style="text-align: center;">{{text}}</div>
  </div>
</template>

<script>
  import Top from '../components/Top'
  import Icon from '../components/Icon'
  import Iconsuccess from '../components/Iconsuccess'
  import Buttons from '../components/Buttons'
  import translate from '../common/Translate.js'
  import { checkDevice, getInviteName } from '../common/Common.js'
  export default {
    data () {
      return {
        isPC: checkDevice(),
        name: getInviteName(),
        title1: translate('newInviteTitle5', this.$route.query['invitename']),
        title2: translate('newInviteTitle6', this.$route.query['invitegroup']),
        title3: translate('Account registered. Welcome to Crait!'),
        title4: translate('newInviteTitle8', this.$route.query['inviteTeam']),
        text: translate('Login to Crait with this account to start messaging')
      }
    },
    components: {
      Top, Icon, Iconsuccess, Buttons
    },
    created () {
    },
    mounted () {
      if (!this.isPC) {
        let inviteSuccess = document.getElementById('invite-success')
        // icon margin top is 80px.
        let topHeight = (window.screen.height - inviteSuccess.offsetHeight - 50 + 80) / 3
        // console.log(inviteSuccess.offsetHeight)
        inviteSuccess.style.top = topHeight + 50 - 80 + 'px'
      }
    }
  }
</script>

<style lang="less" scoped>
  @import '../../assets/css/_mixin.less';
  .invite-success {
    .white-bg();
    height: 450px;
    margin-top: -225px;
    p {
      width: 300px;
      text-align: center;
      font-size: 18px;
      margin: 0 auto;
      margin-top: 20px;
    }
    .title {
      width: 300px;
      margin: 0 auto;
      margin-top: 20px;
      color: #666666;
      line-height: 20px;
    }
  }
  .invite-success-mobile {
    .white-mobile-bg();
    min-height: 300px;
    p {
      width: 300px;
      text-align: center;
      font-size: 18px;
      margin: 0 auto;
      margin-top: 20px;
    }
    .title {
      width: 300px;
      margin: 0 auto;
      margin-top: 20px;
      color: #666666;
      line-height: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// Invitesuccess.vue?3c086a48